import React from 'react'
import { Box } from '@mui/material'

type Props = {
  totalCount: number | string
  className?: string
  title?: string
  unit?: string
}

const TotalCountCard = (props: Props) => {
  const { totalCount, className, title, unit } = props
  return (
    <div className={`flex justify-center items-center ${className}`}>
      <Box
        sx={{
          borderColor: 'primary.main',
          color: 'primary.main',
          backgroundColor: 'white',
        }}
        className="border rounded-lg py-6 px-2 w-full text-center hover:bg-opacity-50"
      >
        <div className="text-sm font-semibold truncate">{title || 'Total Count'}</div>
        <div className="text-lg font-bold">
          {totalCount}
          {unit ? ` ${unit}` : ''}
        </div>
      </Box>
    </div>
  )
}

export default TotalCountCard
